import { render, staticRenderFns } from "./meituanimportform.vue?vue&type=template&id=1b2748fe&scoped=true&"
import script from "./meituanimportform.vue?vue&type=script&lang=js&"
export * from "./meituanimportform.vue?vue&type=script&lang=js&"
import style0 from "./meituanimportform.vue?vue&type=style&index=0&id=1b2748fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2748fe",
  null
  
)

export default component.exports